// extracted by mini-css-extract-plugin
export var equalColumn = "_ho-0";